import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useTimeZoneReducer = () => useSelector((state: ApplicationState) => state.timeZone);
